var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.985 511.985",
    style: {
      enableBackground: "new 0 0 511.985 511.985"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED5564"
    },
    d: "M423.045,111.903c-9.156-21.515-22.202-40.92-38.795-57.702 c-16.703-16.89-36.078-30.187-57.593-39.514C304.189,4.937,280.425,0,255.988,0c-24.421,0-48.202,4.938-70.67,14.687 c-21.515,9.328-40.89,22.625-57.592,39.514c-16.593,16.781-29.647,36.187-38.804,57.702c-9.46,22.234-14.265,45.592-14.265,69.419 c0,51.936,25.671,90.326,58.17,138.917c27.616,41.295,61.99,92.684,91.185,168.807c3.133,8.578,13.335,22.938,31.976,22.938 c18.546,0,28.779-13.469,31.904-21.438l0.047-0.109c29.297-77.014,63.795-128.809,91.514-170.416 c32.326-48.561,57.873-86.903,57.873-138.699C437.326,157.495,432.513,134.137,423.045,111.903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9ED"
    },
    d: "M74.658,181.401c0.023,51.905,25.687,90.263,58.17,138.839 c27.616,41.295,61.99,92.684,91.185,168.807c3.133,8.578,13.335,22.938,31.976,22.938c18.546,0,28.779-13.469,31.904-21.438 l0.047-0.109c29.297-77.014,63.795-128.809,91.514-170.416c32.311-48.529,57.842-86.872,57.873-138.621L74.658,181.401 L74.658,181.401z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M74.658,181.323c0,3.625,0.141,7.172,0.383,10.672h361.895c0.234-3.5,0.391-7.047,0.391-10.672 c0-3.562-0.125-7.125-0.344-10.656H74.994C74.783,174.198,74.658,177.76,74.658,181.323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A0D468"
    },
    d: "M319.986,181.323c0,35.343-28.656,63.998-63.998,63.998c-35.343,0-63.998-28.655-63.998-63.998 s28.655-63.998,63.998-63.998C291.33,117.325,319.986,145.98,319.986,181.323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M255.988,117.325c-5.523,0-10.883,0.703-16,2.016 c27.601,7.109,47.998,32.171,47.998,61.982c0,29.827-20.397,54.889-47.998,61.982c5.117,1.312,10.477,2.016,16,2.016 c35.342,0,63.998-28.655,63.998-63.998S291.33,117.325,255.988,117.325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M255.988,255.992c-41.171,0-74.662-33.499-74.662-74.67c0-41.17,33.491-74.654,74.662-74.654 c41.17,0,74.653,33.483,74.653,74.654S297.158,255.992,255.988,255.992z M255.988,127.996c-29.405,0-53.334,23.921-53.334,53.326 s23.929,53.342,53.334,53.342c29.404,0,53.342-23.937,53.342-53.342S285.392,127.996,255.988,127.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCD1D9"
    },
    d: "M255.988,373.316c-5.891,0-10.664,4.781-10.664,10.672V510.25c3.188,1.094,6.734,1.734,10.664,1.734 c3.922,0,7.477-0.609,10.663-1.641V383.988C266.651,378.097,261.879,373.316,255.988,373.316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M423.045,111.903c-9.156-21.515-22.202-40.92-38.795-57.702 c-16.703-16.89-36.078-30.187-57.593-39.514C304.189,4.937,280.425,0,255.988,0c-3.57,0-7.125,0.125-10.664,0.328 c20.679,1.234,40.818,6.031,60.006,14.359c21.499,9.328,40.873,22.625,57.592,39.514c16.594,16.781,29.64,36.187,38.796,57.702 c9.468,22.234,14.265,45.592,14.265,69.419c0,51.795-25.53,90.138-57.873,138.699c-27.718,41.607-62.201,93.402-91.505,170.416 l-0.039,0.109c-2.452,6.25-9.296,15.906-21.093,19.75c3.148,1.062,6.648,1.688,10.516,1.688c18.546,0,28.779-13.469,31.904-21.438 l0.047-0.109c29.297-77.014,63.795-128.809,91.514-170.416c32.326-48.561,57.873-86.903,57.873-138.699 C437.326,157.495,432.513,134.137,423.045,111.903z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.132542e263b6bba45e49a35446eaebfc.svg";
export { ForwardRef as ReactComponent };